import React, { useState } from "react";
import { MobileUploaderHeader } from "./MobileUploaderHeader.js";
import UploadFilesPreview from "../UploaderComponent/UploadFilesPreview.js";
import UploaderEmptyDragArea from "../UploaderComponent/UploaderDropArea.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";

const MobileUploaderFirstPage = () => {
  const [listView, setListView] = useState(false);
  const { uploaderGetFiles } = useUploader();

  return (
    <div className="mobile-uploader-first-page">
      <MobileUploaderHeader {...{ listView, setListView }} />
      {uploaderGetFiles().length > 0 ? (
        <UploadFilesPreview listView={listView} />
      ) : (
        <UploaderEmptyDragArea />
      )}
    </div>
  );
};
export default MobileUploaderFirstPage;
